import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FinancialPermissionLevel} from 'src/app/permission/enums/financialPermissionLevel.enum';
import PermissionLevel from 'src/app/permission/enums/permissionLevel.enum';
import SectionsAccess from 'src/app/permission/enums/sectionsAccess.enum';
import {CheckPermissionsDirective, NoPermissionAction} from '../../directives/check-permissions.directive';
import ViewAsInvestorPermission from 'src/app/permission/enums/view-as-investor-permission';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {CommonModule} from '@angular/common';
import {LoaderComponent} from '../../loader/loader.component';

const ANGULAR_MATERIAL = [MatIconModule, MatButtonModule];

@Component({
  selector: 'terra-buttons',
  standalone: true,
  imports: [CommonModule,
    ...ANGULAR_MATERIAL,
    CheckPermissionsDirective,
    LoaderComponent],
  templateUrl: './buttons.component.html',
  styleUrls: ['./buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonsComponent implements OnInit {
  @Input() type: 'primary' | 'secondary' | 'small' | 'icon' | 'link' | 'secondary-error' = 'primary';
  @Input() label = 'Action';
  @Input() disabledBtn = false;
  @Input() icon = '';
  @Input() outlinedIcon = false;

  @Input() iconPosition: 'left' | 'right' = 'left';

  @Input() popupOnPermission = false;

  @Input() minimumPermissionLevel: PermissionLevel;
  @Input() minimumFinancialPermissionLevel: FinancialPermissionLevel;
  @Input() sectionsAccess: SectionsAccess;
  @Input() requireContactsVisibility = false;
  @Input() minimumViewAsInvestorPermission: ViewAsInvestorPermission;
  @Input() loading = false;

  NoPermissionAction = NoPermissionAction;

  @Output() onClick = new EventEmitter<any>();

  constructor() {
  }

  ngOnInit(): void {
  }

  btnClick(event) {
    this.onClick.emit(event);
  }
}
